import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { getAppUpdateUrl } from './services/appVersion';

async function startApp() {
  if (import.meta.env.PROD) {
    const updateUrl = await getAppUpdateUrl(__APP_VERSION__, window.location.href);
    if (updateUrl) {
      window.location.replace(updateUrl);
      return;
    }
  }
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

void startApp();
